var $table;
var pageSize;
var pageIndex;
$(document).ready(function(){
	
	$table = $("#yachtResultTable");
	pageSize = 30;
	pageIndex = 0;
	
	refreshTable();
	
	$(".pager-list").on("click","a.page",function(){
		
		var pIndex = parseInt($(this).html()) - 1;
		
		pageIndex = pIndex;
		refreshTable();		
	});
	
	$(".pager-prevnext.prev").click(function(){			
		if(pageIndex > 0){
			pageIndex--;
			refreshTable();
		}
	});
	
	$(".pager-prevnext.next").click(function(){
		if(pageIndex < getPageNum() - 1){
			pageIndex++;
			refreshTable();
		}
	});
	
	$( document ).on( "yacht_filter_event", function( event ) {
		pageIndex=0;
		refreshTable();
	})
});

function getVisibleYachtCount(){
	return $table.find("div.item[data-visible=true]").length;
}

function getPageNum(){
	var visibleYachtCount = getVisibleYachtCount();
	if(visibleYachtCount == 0){
		$(".result-total").hide();
		$(".resultNotFound").show();
		
	}
	else{
		$(".result-total").show();
		$(".resultNotFound").hide();
	}
	return Math.ceil(visibleYachtCount / pageSize);
}

function refreshTable(){
	var pageNum;
	if(getVisibleYachtCount == 0)
		pageNum = 0;
	else
		pageNum = getPageNum();
	
	$("#pager-totalResult").text(getVisibleYachtCount());
	$("#result-total").text(getVisibleYachtCount());
	var allRows = $('div.item');
	var visibleRows = $('div.item[data-visible=true]');

	$table.find(allRows).hide();
	$table.find(visibleRows).slice(pageSize * pageIndex,pageSize * (pageIndex + 1)).show();
	
	if(pageNum <= 1){
		$(".pager-list").hide();
	} else {
		$(".pager-list").show();
		TABLE_PAGER.setPage(pageIndex, pageNum);	
	}
}